import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect } from "vue"
import _imports_0 from '@/img/common/chevron_up.svg'
import _imports_1 from '@/img/common/chevron_down.svg'


const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = ["onUpdate:modelValue"]
const _hoisted_3 = ["onUpdate:modelValue"]
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "d-flex" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick", "disabled"]
const _hoisted_8 = ["onClick", "disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", null, _toDisplayString(_ctx.label), 1),
    _createElementVNode("button", {
      class: "btn btn-sm btn-success ms-2",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.add && _ctx.add(...args)))
    }, " + "),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localValue, (item, i) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "d-flex align-items-center mb-2",
        key: i
      }, [
        _createElementVNode("div", null, _toDisplayString(i + 1) + ". ", 1),
        (!_ctx.options || _ctx.options.length == 0)
          ? _renderSlot(_ctx.$slots, "default", {
              key: 0,
              item: _ctx.localValue[i]
            }, () => [
              _withDirectives(_createElementVNode("input", {
                class: "me-2 form-control",
                type: "text",
                "onUpdate:modelValue": ($event: any) => ((_ctx.localValue[i]) = $event)
              }, null, 8, _hoisted_2), [
                [_vModelText, _ctx.localValue[i]]
              ])
            ])
          : _withDirectives((_openBlock(), _createElementBlock("select", {
              key: 1,
              class: "me-2 form-control",
              "onUpdate:modelValue": ($event: any) => ((_ctx.localValue[i]) = $event)
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getAvailableOptions(i), (item) => {
                return (_openBlock(), _createElementBlock("option", { value: item }, _toDisplayString(item), 9, _hoisted_4))
              }), 256))
            ], 8, _hoisted_3)), [
              [_vModelSelect, _ctx.localValue[i]]
            ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            class: "btn btn-sm btn-danger ms-2",
            onClick: ($event: any) => (_ctx.remove(i))
          }, " - ", 8, _hoisted_6),
          _createElementVNode("button", {
            class: "btn btn-sm btn-link ms-2",
            onClick: ($event: any) => (_ctx.moveUp(i)),
            disabled: i == 0
          }, _cache[1] || (_cache[1] = [
            _createElementVNode("img", { src: _imports_0 }, null, -1)
          ]), 8, _hoisted_7),
          _createElementVNode("button", {
            class: "btn btn-sm btn-link ms-2",
            onClick: ($event: any) => (_ctx.moveDown(i)),
            disabled: i == _ctx.localValue.length - 1
          }, _cache[2] || (_cache[2] = [
            _createElementVNode("img", { src: _imports_1 }, null, -1)
          ]), 8, _hoisted_8)
        ])
      ]))
    }), 128))
  ]))
}